/* global GoogleAnalyticsTracker $ */
import React, { PureComponent } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import RatingDots from '../../lib/Components/RatingDots'
import styles from './FeaturedCarsSlider.module.sass'

class FeaturedCarsSlider extends PureComponent {
  state = {
    carsLoaded: !!this.props.cars,
    carsList: this.props.cars ? this.props.cars : [],
    loadImages: !this.props.lazyload,
    navigationOccurred: false,
  }

  _initCars() {
    if (this.state.carsList.length) {
      // We have hidden this from the markup outside react
      $('.featured-cars-slider-placeholder').hide()
      $('.featured_cars_list').show()

      const sliderGeneralOptions = {
        horizontal: 1,
        mouseDragging: 1,
        touchDragging: 1,
        speed: 300,
        moveBy: 254,
        easing: 'swing',
        releaseSwing: 1,
        startAt: 0,
        smart: true,
      }

      if ($('body').hasClass('mobile_layout')) {
        $(this.sliderFrame).sly({
          horizontal: 1,
          itemNav: 'basic',
          mouseDragging: 1,
          touchDragging: 1,
          speed: 300,
          releaseSwing: true,
        })
      } else if (this.props.usePageNavigation === 'true') {
        $(this.sliderFrame).sly(
          Object.assign(sliderGeneralOptions, {
            itemNav: 'basic',
            prevPage: $(this.prevRef),
            nextPage: $(this.nextRef),
          })
        )
      } else if (this.props.searchResultsV2 === 'true') {
        // Backwards compatibility until V2 of Desktop Search Results is released
        // After that, replace the last condition with this one
        $(this.sliderFrame).sly(
          Object.assign(sliderGeneralOptions, {
            itemNav: 'basic',
            startAt: 0,
            prevPage: $(this.prevRef),
            nextPage: $(this.nextRef),
          })
        )
      } else {
        $(this.sliderFrame).sly(
          Object.assign(sliderGeneralOptions, {
            itemNav: 'forceCentered',
            startAt: 1,
            prev: $(this.prevRef),
            next: $(this.nextRef),
          })
        )
      }

      $(this.sliderFrame).sly('one', 'move start', () => this.setState({ navigationOccurred: true }))

      $(this.sliderFrame).sly('one', 'move start', function() {
        GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
          `Featured Cars Slider slided`
        )
      })
    } else if (this.state.carsLoaded) {
      $('.featured-cars-slider-placeholder').hide()
      $('.search-results-section__heading').hide()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.carsLoaded !== this.state.carsLoaded) {
      this._initCars()
    }
  }

  componentDidMount() {
    this._initCars()
  }

  async componentWillMount() {
    if (this.state.carsLoaded) {
      return
    }
    try {
      const res = await fetch(this.props.featuredCarsUrl)
      const cars = await res.json()

      await this._setStateWhenReady({ carsLoaded: true, carsList: cars })
    } catch (err) {
      console.warn(err)
    }
  }

  _setStateWhenReady(state) {
    return new Promise(resolve => {
      this.setState(state, resolve)
    })
  }

  _renderCarImage = (car, i) => {
    // The default number of eager-loaded images in the featured carousel is set here
    const { lazyload, eagerloadCount = 4, willBeInView } = this.props
    const carImage =
      this.state.navigationOccurred || (i < eagerloadCount && (!lazyload || willBeInView)) ? (
        // All images are lazy-loaded
        <img src={car.image_url} alt={car.headline} />
      ) : (
        <img src='data:image/gif;base64,R0lGODdhAQABAPAAAP///wAAACwAAAAAAQABAEACAkQBADs=' alt='car image placeholder' />
      )

    return car.missing_image_fallback ? <div className='featured-cars-no-image'>{carImage}</div> : carImage
  }

  _renderFuelEconomy = car => {
    if (this.props.emissionInformation === null) {
      return
    }

    let parts = []

    if (car.energy_consumption) {
      parts.push(<span>{car.energy_consumption}</span>)
    }
    if (car.fuel_economy) {
      parts.push(<span className='consumption'>{car.fuel_economy}</span>)
    }
    if (car.co2_emission) {
      parts.push(<span className='co2'>{car.co2_emission}</span>)
    }

    return (
      <div className={`fuel-efficiency ${this.props.country || 'en'}`}>
        {parts.length > 0 && parts.reduce((prev, curr) => [prev, ' | ', curr])}
      </div>
    )
  }

  _renderRatings = car => (
    <span>
      <div className={`au-rating-label-flat value${car.au_rating}`}>{car.rating_label}</div>
      <RatingDots rating={car.au_rating} />
    </span>
  )

  _trackClick = car => {
    // converting _ to spaces for backwards data compatibility in GA
    let sliderRef = this.props.sliderRef.split('_').join(' ')
    let isNewCar = car.is_new_car ? ' - new car' : ''
    GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
      `Featured Cars Slider click - ${sliderRef}`,
      car.link_target_blank ? `outgoing ${isNewCar}` : `inbound ${isNewCar}`,
      null, null, true
    )
  }

  _trackSlide = () => {
    GoogleAnalyticsTracker.trackFeaturedCarsSliderEvent(
      `Featured Cars Slider slided`
    )
  }

  _renderCarsList = (carsArray = []) => {
    carsArray = this.props.reverseList ? carsArray.reverse() : carsArray
    const { props } = this

    return carsArray.map((car, i) => (
      <div className='featured-cars-slider__car' key={car.id} onClick={() => this._trackClick(car)}>
        <a
          href={car.redirect_url}
          target={car.link_target_blank ? '_blank' : null}
          rel={car.link_target_blank ? 'noopener' : null}
          data-js-outgoing-link={car.link_target_blank ? true : null}
          data-featured={car.is_featured ? true : null}
          data-car-id={car.id}
          data-car-price={car.price}
        >
          <div className='featured-cars-slider__image'>
            {car.rounded_estimated_price && (car.rounded_estimated_price > car.price) && (
              <div className='savings-label'>
                {car.price_difference_formatted}
              </div>
            )}
            {this._renderCarImage(car, i)}
            {car.distance_to_car && <div className='distance-to-search-location visible'>{car.distance_to_car}</div>}
          </div>

          <div className='featured-cars-slider__bottom'>
            <div className='featured-cars-slider__row'>
              <div className='featured-cars-slider__rating-container'>
                {this._renderRatings(car)}
              </div>

              <div className='featured-cars-slider__price-container'>
                <p className='car-price'> {car.formatted_price} </p>
                { !car.is_new_car && (
                  <div className='valuation-wrapper'>
                    <span className='label'> {car.valuation_label} </span>
                    {props.searchResultsV2 ? <br /> : ''}
                    <span className='value'> {car.valuation_value} </span>
                  </div>
                )}
              </div>
            </div>

            <div className='featured-cars-slider__row-separator' />

            <div className='featured-cars-slider__row-source'>
              {car.location_complete ? (
                <p className='featured-cars-slider__location'>{car.location_complete}</p>
              ) : (
                <p className='featured-cars-slider__location-placeholder' />
              )}
              {this._renderFuelEconomy(car)}
              <div className='featured-cars-slider__source-name'>
                <span className={`moving-text ${car.link_target_blank ? 'external' : 'internal'}`}>
                  {car.source_name}
                </span>
                &nbsp;
                {car.link_target_blank ? (
                  <i className='icon_inline moving-link-indicator' />
                ) : (
                  <span className='moving-link-indicator'>›</span>
                )}
              </div>
            </div>
          </div>
        </a>
      </div>
    ))
  }

  render() {
    const { state, props, _renderCarsList } = this

    return (
      <div>
        {props.sectionHeadline && <h4 className={styles.sectionHeadline}>{props.sectionHeadline}</h4>}
        <div className='featured-cars-slider'>
          <div
            className='featured-cars-slider__frame frame'
            ref={sliderFrame => {
              this.sliderFrame = sliderFrame
            }}
          >
            <div
              className={` featured-cars-slider featured-cars-slider--simple slidee
              ${props.usePageNavigation === 'true' ? 'page-navigation' : ''}
              ${props.searchResultsV2 === 'true' ? 'v2' : ''}`}
            >
              {state.carsLoaded ? _renderCarsList(state.carsList) : 'Loading cars'}
            </div>
          </div>
          <div className='featured-cars-slider__controls'>
            <div
              className='featured-cars-slider__prev'
              onClick={() => this._trackSlide()}
              ref={prevRef => {
                this.prevRef = prevRef
              }}
            />
            <div
              className='featured-cars-slider__next'
              onClick={() => this._trackSlide()}
              ref={nextRef => {
                this.nextRef = nextRef
              }}
            />
          </div>
        </div>
      </div>
    )
  }
}

FeaturedCarsSlider.propTypes = {
  featuredCarsUrl: PropTypes.string,
  country: PropTypes.string,
  emissionInformation: PropTypes.string,
  reverseList: PropTypes.string,
  sliderRef: PropTypes.string,
  cars: PropTypes.array,
  sectionHeadline: PropTypes.string,
  usePageNavigation: PropTypes.string,
  searchResultsV2: PropTypes.string,
  lazyload: PropTypes.bool,
  eagerloadCount: PropTypes.number,
  willBeInView: PropTypes.bool,
  version: PropTypes.string,
}

export default FeaturedCarsSlider
